/**
 * User: CHT
 * Date: 2020/5/8
 * Time: 14:01
 */
import { uuid, vector, mark } from './index';
import { Direction, DIRECTION_VECTOR } from './types';
export default class GraphNode {
    $options;
    key;
    graph;
    coordinate;
    meta;
    merge; // 节点是否为合并节点
    hidden; // 节点是否需要隐藏
    _width; // 宽度
    _height; // 高度
    angleList;
    constructor(props, graph) {
        const { width = 180, height = 100, coordinate = [0, 0], meta = null, merge = false, // 是否合并
        hidden = false, // 是否隐藏
         } = props;
        this.$options = props;
        const id = props[mark.relationMark] || uuid('node');
        this.key = uuid('node');
        this.graph = graph;
        this[mark.relationMark] = id;
        this.coordinate = [...coordinate];
        this.meta = meta;
        this.merge = merge;
        this.hidden = hidden;
        this.width = width;
        this.height = height;
    }
    get position() {
        return vector(this.coordinate).add(this.graph.origin).end;
    }
    set position(position) {
        this.coordinate = vector(position).minus(this.graph.origin).end;
    }
    get center() {
        return vector(this.coordinate).add([this.width / 2, this.height / 2]).end;
    }
    set center(position) {
        this.coordinate = vector(position).minus([this.width / 2, this.height / 2]).end;
    }
    get width() {
        return this._width;
    }
    set width(w) {
        w = Math.floor(w);
        // this._width = w > 50 ? w : 50;
        this._width = w > 0 ? w : 0;
        // this.angle();
    }
    get height() {
        return this._height;
    }
    set height(h) {
        h = Math.floor(h);
        this._height = h > 0 ? h : 0;
        // this.angle();
    }
    // angle() {
    //   const w = this.width / 2,
    //     h = this.height / 2,
    //     center = [0, 0];
    //   const topLeft = vector(center).minus([w, h]).angle().end;
    //   const topRight = vector(center).add([w, 0]).minus([0, h]).angle().end;
    //   const bottomRight = vector(center).add([w, h]).angle().end;
    //   const bottomLeft = vector(center).add([0, h]).minus([w, 0]).angle().end;
    //   // 角度
    //   this.angleList = [topLeft, topRight, bottomRight, bottomLeft];
    // }
    relative(offset) {
        // const angle = vector(offset)
        //   .minus([this.width / 2, this.height / 2])
        //   .angle().end;
        // const angleList = this.angleList;
        // const directionList = [Direction.TOP, Direction.RIGHT, Direction.BOTTOM, Direction.LEFT];
        // let dir = Direction.LEFT;
        // angleList.reduce((prev, current, idx) => {
        //   if (angle >= prev && angle < current) {
        //     dir = directionList[idx - 1];
        //   }
        //   return current;
        // });
        const x = offset[0];
        const dir = x === 0 ? Direction.LEFT : Direction.RIGHT;
        return {
            position: this.fixOffset(offset, dir),
            direction: DIRECTION_VECTOR[dir],
        };
    }
    fixOffset(offset, dir) {
        let END_HEIGHT = 32;
        if (this.meta?.extParam?.isDragElement) {
            END_HEIGHT = 16;
        }
        switch (dir) {
            case Direction.TOP:
                offset[0] = this.width / 2;
                offset[1] = 0;
                break;
            case Direction.RIGHT:
                offset[0] = this.width;
                offset[1] = this.height ? END_HEIGHT / 2 : 0;
                // offset[1] = this.height / 2;
                break;
            case Direction.BOTTOM:
                offset[0] = this.width / 2;
                offset[1] = this.height;
                break;
            case Direction.LEFT:
            default:
                offset[0] = 0;
                offset[1] = this.height ? END_HEIGHT / 2 : 0;
                // offset[1] = this.height / 2;
                break;
        }
        return offset;
    }
    remove() {
        return this.graph.removeNode(this);
    }
    toJSON() {
        return {
            [mark.relationMark]: this[mark.relationMark],
            width: this.width,
            height: this.height,
            coordinate: [...this.coordinate],
            meta: this.meta,
            merge: this.merge,
            hidden: this.hidden,
        };
    }
}
